export class NetworkError extends Error {}
export class ValidationError extends Error {}
export class UnauthorizedError extends Error {}
export class ForbiddenError extends Error {}
export class ApiError extends Error {}
